(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3postcompra-cruzadas"] && !Shopify.designMode) return;
  try {
    
(function () {
  var __wrapEs = document.querySelector('[data-pcx-solo-es]');
  if (__wrapEs) {
    var __idioma = (navigator.language || 'es').slice(0, 2).toLowerCase();
    if (__idioma === 'es') {
      __wrapEs.removeAttribute('hidden');
    } else {
      __wrapEs.remove();
      return;
    }
  }

  function inicializar(seccion) {
    var elMin = seccion.querySelector('[data-pcx-min]');
    var elSeg = seccion.querySelector('[data-pcx-seg]');
    if (elMin && elSeg) {
      var duracion = parseInt(seccion.getAttribute('data-duracion-timer'), 10) || 12;
      var clave = 'pcx_timer_fin';
      var fin;
      try {
        fin = parseInt(sessionStorage.getItem(clave), 10);
      } catch (e) {
        fin = 0;
      }
      if (!fin || fin < Date.now()) {
        fin = Date.now() + duracion * 60000;
        try {
          sessionStorage.setItem(clave, fin);
        } catch (e) {}
      }
      function rellenar(n) {
        return n < 10 ? '0' + n : '' + n;
      }
      function actualizar() {
        var restante = Math.max(0, Math.floor((fin - Date.now()) / 1000));
        elMin.textContent = rellenar(Math.floor(restante / 60));
        elSeg.textContent = rellenar(restante % 60);
        if (restante <= 0) {
          fin = Date.now() + duracion * 60000;
          try {
            sessionStorage.setItem(clave, fin);
          } catch (e) {}
        }
      }
      actualizar();
      setInterval(actualizar, 1000);
    }

    seccion.querySelectorAll('[data-pcx-producto]').forEach(function (tarjeta) {
      var boton = tarjeta.querySelector('[data-pcx-anadir]');
      if (!boton) return;
      boton.addEventListener('click', function () {
        var idVariante = tarjeta.getAttribute('data-variante');
        if (!idVariante) return;
        boton.classList.add('pcx-cargando');
        var formulario = document.createElement('form');
        formulario.setAttribute('action', '/cart/add');
        formulario.setAttribute('method', 'post');
        formulario.style.display = 'none';
        var campo = document.createElement('input');
        campo.setAttribute('type', 'hidden');
        campo.setAttribute('name', 'id');
        campo.setAttribute('value', idVariante);
        var cantidad = document.createElement('input');
        cantidad.setAttribute('type', 'hidden');
        cantidad.setAttribute('name', 'quantity');
        cantidad.setAttribute('value', '1');
        formulario.appendChild(campo);
        formulario.appendChild(cantidad);
        document.body.appendChild(formulario);
        if (formulario.requestSubmit) {
          formulario.requestSubmit();
        } else {
          formulario.submit();
        }
        setTimeout(function () {
          boton.classList.remove('pcx-cargando');
          formulario.remove();
        }, 1200);
      });
    });
  }

  document.querySelectorAll('[data-pcx]').forEach(inicializar);

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('[data-pcx]');
    if (seccion) inicializar(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["5postcompra-resena"] && !Shopify.designMode) return;
  try {
    
(function () {
  function inicializar(seccion) {
    if (seccion.getAttribute('data-pcr-listo')) return;
    seccion.setAttribute('data-pcr-listo', '1');

    var idioma = (navigator.language || 'es').slice(0, 2).toLowerCase();
    if (['es','it','fr','de','en'].indexOf(idioma) === -1) idioma = 'en';
    function dato(c) { return seccion.getAttribute('data-'+c+'-'+idioma) || seccion.getAttribute('data-'+c+'-en') || seccion.getAttribute('data-'+c+'-es') || ''; }
    function poner(sel, val) {
      var el = seccion.querySelector(sel);
      if (!el) return;
      if (val && val.trim() !== '') { el.textContent = val; el.removeAttribute('hidden'); }
      else { el.setAttribute('hidden', ''); }
    }
    function ph(sel, val) { var el = seccion.querySelector(sel); if (el) el.setAttribute('placeholder', val); }

    poner('[data-pcr-titulo]', dato('titulo'));
    poner('[data-pcr-texto]', dato('texto'));
    poner('[data-pcr-fbtitulo]', dato('fbtitulo'));
    var elPista = seccion.querySelector('[data-pista]'); if (elPista) elPista.textContent = dato('pista');
    var elBoton = seccion.querySelector('[data-pcr-boton]'); if (elBoton) elBoton.textContent = dato('boton');
    var elExito = seccion.querySelector('[data-pcr-exito]'); if (elExito) elExito.textContent = dato('exito');
    var ERROR = {
      es: 'Revisa los campos e inténtalo de nuevo.',
      it: 'Controlla i campi e riprova.',
      fr: 'Vérifie les champs et réessaie.',
      de: 'Bitte prüfe die Felder und versuche es erneut.',
      en: 'Please check the fields and try again.'
    };
    var elError = seccion.querySelector('[data-pcr-error]'); if (elError) elError.textContent = ERROR[idioma] || ERROR.en;
    ph('[data-pcr-phcom]', dato('phcom'));
    ph('[data-pcr-phmail]', dato('phmail'));

    // Ayuda
    var textoAyuda = dato('ayuda');
    var cajaAyuda = seccion.querySelector('[data-pcr-ayuda-caja]');
    var elAyuda = seccion.querySelector('[data-pcr-ayuda]');
    var elContacto = seccion.querySelector('[data-pcr-contacto]');
    var enlaceContacto = seccion.getAttribute('data-enlace-contacto') || '';
    if (textoAyuda && textoAyuda.trim() !== '' && cajaAyuda) {
      if (elAyuda) elAyuda.textContent = textoAyuda;
      cajaAyuda.removeAttribute('hidden');
    }
    if (elContacto && enlaceContacto && enlaceContacto.trim() !== '') {
      /* Si es un enlace de WhatsApp sin texto, el chat se abre con un mensaje ya empezado */
      var MENSAJE = {
        es: 'Hola, tengo un problema con mi pedido de MERCURYAL: ',
        it: 'Ciao, ho un problema con il mio ordine MERCURYAL: ',
        fr: 'Bonjour, j\'ai un problème avec ma commande MERCURYAL : ',
        de: 'Hallo, ich habe ein Problem mit meiner MERCURYAL-Bestellung: ',
        en: 'Hi, I have a problem with my MERCURYAL order: '
      };
      var destino = enlaceContacto.trim();
      if (/wa\.me\/|whatsapp\.com/i.test(destino) && destino.indexOf('text=') === -1) {
        destino += (destino.indexOf('?') === -1 ? '?' : '&') + 'text=' + encodeURIComponent(MENSAJE[idioma] || MENSAJE.en);
      }
      var elContactoTexto = seccion.querySelector('[data-pcr-contacto-texto]');
      if (elContactoTexto) elContactoTexto.textContent = dato('contacto');
      elContacto.setAttribute('href', destino);
      elContacto.removeAttribute('hidden');
    }

    var estrellas = seccion.querySelectorAll('[data-estrella]');
    var formulario = seccion.querySelector('[data-formulario]');
    var campoValoracion = seccion.querySelector('[data-campo-valoracion]');
    var pista = seccion.querySelector('[data-pista]');
    if (!estrellas.length) return;

    var umbral = parseInt(seccion.getAttribute('data-umbral'), 10) || 4;
    var enlaceAmazon = (seccion.getAttribute('data-amazon-es') || '').trim();
    var asinLiquid = (seccion.getAttribute('data-asin') || '').trim().toUpperCase();
    var elAlt = seccion.querySelector('[data-pcr-alt]');
    var seleccion = 0;

    /* Tras enviar el formulario la página se recarga: lo dejamos abierto
       para que el cliente vea el mensaje de éxito o de error. */
    if (formulario && (elExito || elError)) formulario.classList.add('pc-resena-formulario--visible');

    /* ---------- Enlace a la reseña de Amazon (igual que el popup) ---------- */
    var DOMINIOS = { es: 'amazon.es', it: 'amazon.it', fr: 'amazon.fr', de: 'amazon.de', en: 'amazon.co.uk' };
    var ALTERNATIVA = {
      es: '¿No se ha abierto Amazon? Toca aquí',
      it: 'Amazon non si è aperto? Tocca qui',
      fr: 'Amazon ne s\'est pas ouvert ? Touche ici',
      de: 'Amazon hat sich nicht geöffnet? Hier tippen',
      en: 'Amazon didn\'t open? Tap here'
    };

    /* País del cliente por IP (lo detecta Shopify). Se pide al cargar para tenerlo
       listo antes del toque. Si falla o el país no está en la lista, manda el idioma. */
    var PAISES = { ES: 'amazon.es', PT: 'amazon.es', IT: 'amazon.it', FR: 'amazon.fr', BE: 'amazon.fr',
                   DE: 'amazon.de', AT: 'amazon.de', GB: 'amazon.co.uk', IE: 'amazon.co.uk' };
    var dominioPorIP = '';
    try {
      fetch('/browsing_context_suggestions.json?country[enabled]=true')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
          if (c && PAISES[String(c).toUpperCase()]) dominioPorIP = PAISES[String(c).toUpperCase()];
        })
        .catch(function () {});
    } catch (e) {}

    /* El ASIN sale del único ajuste (Amazon.es): vale un enlace completo o solo el ASIN. */
    function datosAmazon() {
      var m = enlaceAmazon.match(/(?:asin=|\/dp\/|\/product-reviews\/|\/gp\/product\/)([A-Z0-9]{10})/i) ||
              enlaceAmazon.match(/^([A-Z0-9]{10})$/i);
      var asin = m ? m[1].toUpperCase() : (/^[A-Z0-9]{10}$/.test(asinLiquid) ? asinLiquid : '');
      if (!asin) return null;
      return { asin: asin, dom: dominioPorIP || DOMINIOS[idioma] || 'amazon.es' };
    }

    function pintar(hasta) {
      estrellas.forEach(function (estrella, indice) {
        estrella.classList.toggle('pc-resena-estrella--activa', indice < hasta);
      });
    }

    function irAmazon() {
      var d = datosAmazon();
      if (pista) pista.textContent = dato('gracias');
      if (!d) return;

      /* Ruta probada: abre el formulario de reseña dentro de la app */
      var ruta = '/review/create-review/?ie=UTF8&channel=glance-detail&asin=' + d.asin;
      var web = 'https://www.' + d.dom + ruta;
      var ua = navigator.userAgent;
      var esAndroid = /Android/i.test(ua);
      var esIOS = /iPhone|iPad|iPod/i.test(ua);

      if (!esAndroid && !esIOS) { window.location.href = web; return; }

      /* Si la app se abre, la página pasa a segundo plano. Si sigue visible,
         enseñamos un botón manual en vez de redirigir solos. */
      var salio = false;
      function marcar() { salio = true; }
      document.addEventListener('visibilitychange', function () { if (document.hidden) marcar(); });
      window.addEventListener('pagehide', marcar);
      setTimeout(function () {
        if (salio || document.hidden || !elAlt) return;
        elAlt.textContent = ALTERNATIVA[idioma] || ALTERNATIVA.en;
        elAlt.setAttribute('href', web);
        elAlt.removeAttribute('hidden');
      }, 2500);

      if (esAndroid) {
        window.location.href = 'intent://www.' + d.dom + ruta +
          '#Intent;scheme=https;package=com.amazon.mShop.android.shopping;' +
          'S.browser_fallback_url=' + encodeURIComponent(web) + ';end';
      } else {
        window.location.href = 'com.amazon.mobile.shopping.web://' + d.dom + ruta;
      }
    }

    estrellas.forEach(function (estrella) {
      estrella.addEventListener('mouseenter', function () {
        pintar(parseInt(estrella.getAttribute('data-valor'), 10));
      });
      estrella.addEventListener('click', function () {
        seleccion = parseInt(estrella.getAttribute('data-valor'), 10);
        pintar(seleccion);
        if (campoValoracion) campoValoracion.value = seleccion + '/5';
        if (seleccion >= umbral) {
          if (formulario) formulario.classList.remove('pc-resena-formulario--visible');
          /* Sin setTimeout: el salto a la app tiene que salir del propio toque */
          irAmazon();
        } else {
          if (elAlt) elAlt.setAttribute('hidden', '');
          if (formulario) formulario.classList.add('pc-resena-formulario--visible');
          if (pista) pista.textContent = '';
        }
      });
    });

    var zonaEstrellas = seccion.querySelector('[data-estrellas]');
    if (zonaEstrellas) {
      zonaEstrellas.addEventListener('mouseleave', function () { pintar(seleccion); });
    }
  }

  document.querySelectorAll('[data-pc-resena]').forEach(inicializar);
  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('[data-pc-resena]');
    if (seccion) inicializar(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Barra_Superior"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarAnuncio(seccion) {
      if (seccion.dataset.anuncioListo === 'true') return;

      var viewport = seccion.querySelector('.anuncio-viewport');
      var track = seccion.querySelector('[data-track]');
      var grupo = seccion.querySelector('[data-grupo]');
      if (!viewport || !track || !grupo) return;

      var itemsBase = Array.prototype.slice.call(grupo.children);
      if (itemsBase.length === 0) return;

      seccion.dataset.anuncioListo = 'true';

      var velocidad = parseFloat(seccion.dataset.velocidad) || 60;
      var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function construir() {
        track.classList.remove('anuncio-track--animado');
        track.style.animationDuration = '';

        while (grupo.children.length > itemsBase.length) {
          grupo.removeChild(grupo.lastChild);
        }
        var clonGrupo = track.querySelector('[data-grupo-clon]');
        if (clonGrupo) {
          track.removeChild(clonGrupo);
        }

        var anchoViewport = viewport.clientWidth;
        var guarda = 0;
        while (grupo.scrollWidth < anchoViewport && guarda < 60) {
          itemsBase.forEach(function (item) {
            grupo.appendChild(item.cloneNode(true));
          });
          guarda += 1;
        }

        if (reducirMovimiento) return;

        var duplicado = grupo.cloneNode(true);
        duplicado.removeAttribute('data-grupo');
        duplicado.setAttribute('data-grupo-clon', 'true');
        duplicado.setAttribute('aria-hidden', 'true');
        track.appendChild(duplicado);

        var anchoGrupo = grupo.scrollWidth;
        var duracion = anchoGrupo / velocidad;
        track.style.animationDuration = duracion.toFixed(2) + 's';
        track.classList.add('anuncio-track--animado');
      }

      construir();

      var temporizador;
      window.addEventListener('resize', function () {
        window.clearTimeout(temporizador);
        temporizador = window.setTimeout(construir, 200);
      });

      var selectIdioma = seccion.querySelector('[data-idioma-select]');
      if (selectIdioma) {
        selectIdioma.addEventListener('change', function () {
          if (selectIdioma.form) {
            selectIdioma.form.submit();
          }
        });
      }
    }

    function iniciarTodos() {
      document.querySelectorAll('[data-anuncio]').forEach(iniciarAnuncio);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodos);
    } else {
      iniciarTodos();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-anuncio]');
      if (seccion) {
        seccion.dataset.anuncioListo = '';
        iniciarAnuncio(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CARRITO"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-carrito-mx]');
  if (!raiz) return;

  var umbral = parseInt(raiz.getAttribute('data-umbral-envio'), 10) || 0;
  var contItems = raiz.querySelector('[data-carrito-items]');
  var elContador = raiz.querySelector('[data-carrito-contador]');
  var elTotal = raiz.querySelector('[data-carrito-total]');
  var elEnvioTexto = raiz.querySelector('[data-envio-texto]');
  var elEnvioProgreso = raiz.querySelector('[data-envio-progreso]');

  function formatearDinero(centimos) {
    return '€' + (centimos / 100).toFixed(2).replace('.', ',');
  }

  function abrir() {
    raiz.classList.add('carrito-mx--abierto');
    document.documentElement.style.overflow = 'hidden';
  }

  function cerrar() {
    raiz.classList.remove('carrito-mx--abierto');
    document.documentElement.style.overflow = '';
  }

  function actualizarEnvio(total) {
    if (!elEnvioTexto || !elEnvioProgreso || umbral <= 0) return;
    if (total >= umbral) {
      elEnvioTexto.textContent = 'Tu pedido cumple los requisitos de envío gratuito.';
      elEnvioProgreso.style.width = '100%';
    } else {
      elEnvioTexto.textContent = 'Te faltan ' + formatearDinero(umbral - total) + ' para el envío gratuito.';
      elEnvioProgreso.style.width = Math.min(100, (total / umbral) * 100) + '%';
    }
  }

  function renderizar(carrito) {
    if (elContador) elContador.textContent = carrito.item_count;
    if (elTotal) elTotal.textContent = formatearDinero(carrito.total_price) + ' EUR';
    actualizarEnvio(carrito.total_price);

    var burbuja = document.querySelector('.cart-count-bubble span[aria-hidden]');
    if (burbuja) burbuja.textContent = carrito.item_count;

    if (!contItems) return;
    if (carrito.items.length === 0) {
      contItems.innerHTML = '<p class="carrito-mx-vacio">Tu cesta está vacía.</p>';
      return;
    }
    var html = '';
    carrito.items.forEach(function (item) {
      var imagen = item.image ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_200x$1$2') : '';
      html += '<div class="carrito-mx-item" data-linea="' + item.key + '">';
      html += '<div class="carrito-mx-item-imagen">' + (imagen ? '<img src="' + imagen + '" alt="" loading="lazy">' : '') + '</div>';
      html += '<div class="carrito-mx-item-centro">';
      html += '<p class="carrito-mx-item-nombre">' + item.product_title + '</p>';
      html += '<div class="carrito-mx-item-precios">';
      html += '<span class="carrito-mx-item-precio">' + formatearDinero(item.final_line_price) + '</span>';
      if (item.original_line_price > item.final_line_price) {
        html += '<span class="carrito-mx-item-precio-antiguo">' + formatearDinero(item.original_line_price) + '</span>';
      }
      html += '</div>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<p class="carrito-mx-item-variante">' + item.variant_title + '</p>';
      }
      html += '</div>';
      html += '<div class="carrito-mx-item-derecha">';
      html += '<input type="number" class="carrito-mx-item-cantidad" value="' + item.quantity + '" min="0" data-cantidad-linea>';
      html += '<button type="button" class="carrito-mx-item-quitar" data-quitar-linea>Quitar</button>';
      html += '</div>';
      html += '</div>';
    });
    contItems.innerHTML = html;
  }

  function refrescar(callbackAbrir) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        renderizar(carrito);
        if (callbackAbrir) abrir();
      });
  }

  function cambiarLinea(clave, cantidad) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: clave, quantity: cantidad })
    })
      .then(function (r) { return r.json(); })
      .then(renderizar);
  }

  function anadirVariante(id, cantidad) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: cantidad || 1 })
    }).then(function () {
      refrescar(true);
    });
  }

  raiz.querySelectorAll('[data-carrito-cerrar]').forEach(function (el) {
    el.addEventListener('click', cerrar);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  contItems.addEventListener('change', function (e) {
    if (e.target.matches('[data-cantidad-linea]')) {
      var linea = e.target.closest('[data-linea]');
      cambiarLinea(linea.getAttribute('data-linea'), parseInt(e.target.value, 10) || 0);
    }
  });

  contItems.addEventListener('click', function (e) {
    if (e.target.matches('[data-quitar-linea]')) {
      var linea = e.target.closest('[data-linea]');
      cambiarLinea(linea.getAttribute('data-linea'), 0);
    }
  });

  raiz.querySelectorAll('[data-sugerido-anadir]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      anadirVariante(boton.getAttribute('data-variante'), 1);
    });
  });

  var pistaSugeridos = raiz.querySelector('[data-sugeridos-pista]');
  var flechaAnterior = raiz.querySelector('[data-sugeridos-anterior]');
  var flechaSiguiente = raiz.querySelector('[data-sugeridos-siguiente]');

  if (pistaSugeridos && flechaAnterior && flechaSiguiente) {
    function pasoSugeridos() {
      var tarjeta = pistaSugeridos.querySelector('[data-sugerido-tarjeta]');
      if (!tarjeta) return pistaSugeridos.clientWidth;
      return tarjeta.getBoundingClientRect().width + 12;
    }

    function actualizarFlechasSugeridos() {
      var maximo = pistaSugeridos.scrollWidth - pistaSugeridos.clientWidth - 2;
      flechaAnterior.disabled = pistaSugeridos.scrollLeft <= 2;
      flechaSiguiente.disabled = pistaSugeridos.scrollLeft >= maximo;
    }

    flechaAnterior.addEventListener('click', function () {
      pistaSugeridos.scrollBy({ left: -pasoSugeridos(), behavior: 'smooth' });
    });

    flechaSiguiente.addEventListener('click', function () {
      pistaSugeridos.scrollBy({ left: pasoSugeridos(), behavior: 'smooth' });
    });

    pistaSugeridos.addEventListener('scroll', actualizarFlechasSugeridos, { passive: true });
    window.addEventListener('resize', actualizarFlechasSugeridos);
    actualizarFlechasSugeridos();
  }

  document.addEventListener('click', function (e) {
    var enlaceCarrito = e.target.closest('a[href$="/cart"], a[href="/cart"], #cart-icon-bubble');
    if (enlaceCarrito) {
      e.preventDefault();
      refrescar(true);
    }
  });

  document.addEventListener('submit', function (e) {
    var formulario = e.target.closest('form[action*="/cart/add"]');
    if (!formulario) return;
    e.preventDefault();
    var datos = new FormData(formulario);
    fetch('/cart/add.js', { method: 'POST', body: datos })
      .then(function (r) { return r.json(); })
      .then(function () {
        refrescar(true);
      });
  });

  refrescar(false);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["FichaProducto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(seccion) {
      if (seccion.dataset.fichaLista === 'true') return;
      seccion.dataset.fichaLista = 'true';

      var slides = Array.prototype.slice.call(seccion.querySelectorAll('.ficha-slide'));
      var minis = Array.prototype.slice.call(seccion.querySelectorAll('[data-miniatura]'));

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var i = mini.dataset.miniatura;
          slides.forEach(function (s) {
            s.classList.toggle('ficha-slide--activa', s.dataset.slide === i);
          });
          minis.forEach(function (m) {
            m.classList.toggle('ficha-miniatura--activa', m === mini);
          });
        });
      });

      var input = seccion.querySelector('[data-cantidad]');
      var pestanas = Array.prototype.slice.call(seccion.querySelectorAll('[data-cantidad-opcion]'));
      if (input && pestanas.length > 0) {
        pestanas.forEach(function (p) {
          p.addEventListener('click', function () {
            input.value = p.dataset.cantidadOpcion;
            pestanas.forEach(function (o) {
              o.classList.toggle('ficha-cantidad-pestana--activa', o === p);
            });
          });
        });
      }

      var select = seccion.querySelector('[data-variante-select]');
      var precio = seccion.querySelector('[data-precio]');
      var precioComp = seccion.querySelector('[data-precio-comparado]');
      if (select && precio) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          if (opt.dataset.precio) precio.textContent = opt.dataset.precio;
          if (precioComp && opt.dataset.precioComparado) {
            precioComp.textContent = opt.dataset.precioComparado;
          }
        });
      }
    }

    function iniciarTodas() {
      document.querySelectorAll('[data-ficha]').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-ficha]');
      if (s) { s.dataset.fichaLista = ''; iniciar(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Novedades"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarSeleccionColor() {
      document.querySelectorAll('.seccion-novedades .novedades-tarjeta').forEach(function (tarjeta) {
        if (tarjeta.dataset.seleccionColorLista === 'true') return;
        tarjeta.dataset.seleccionColorLista = 'true';

        var muestras = tarjeta.querySelectorAll('.novedades-muestra');
        if (muestras.length === 0) return;

        var imagen = tarjeta.querySelector('.novedades-imagen');
        var enlace = tarjeta.querySelector('.novedades-enlace');

        muestras.forEach(function (muestra) {
          muestra.addEventListener('click', function () {
            if (muestra.classList.contains('novedades-muestra--seleccionada')) return;

            muestras.forEach(function (otra) {
              otra.classList.remove('novedades-muestra--seleccionada');
            });
            muestra.classList.add('novedades-muestra--seleccionada');

            if (enlace && muestra.dataset.enlace) {
              enlace.setAttribute('href', muestra.dataset.enlace);
            }

            if (imagen && muestra.dataset.imagen && imagen.getAttribute('src') !== muestra.dataset.imagen) {
              var nuevaImagen = new Image();
              nuevaImagen.onload = function () {
                imagen.removeAttribute('srcset');
                imagen.removeAttribute('sizes');
                imagen.setAttribute('src', muestra.dataset.imagen);
                requestAnimationFrame(function () {
                  imagen.classList.remove('novedades-imagen--cambiando');
                });
              };
              imagen.classList.add('novedades-imagen--cambiando');
              nuevaImagen.src = muestra.dataset.imagen;
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarSeleccionColor);
    } else {
      iniciarSeleccionColor();
    }

    document.addEventListener('shopify:section:load', iniciarSeleccionColor);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["PAGINA_PRODUCTO"] && !Shopify.designMode) return;
  try {
    
(function () {
  function inicializarProducto(seccion) {
    var datosVariantes = null;
    var scriptJson = seccion.parentElement.querySelector('[data-variantes-json]') || document.querySelector('[data-variantes-json]');
    try {
      datosVariantes = JSON.parse(scriptJson.textContent);
    } catch (e) {
      datosVariantes = [];
    }

    var inputVariante = seccion.querySelector('[data-variante-id]');
    var elPrecio = seccion.querySelector('[data-precio]');
    var elPrecioAntiguo = seccion.querySelector('[data-precio-antiguo]');
    var elAhorro = seccion.querySelector('[data-ahorro]');
    var elAhorroValor = seccion.querySelector('[data-ahorro-valor]');
    var elBadge = seccion.querySelector('[data-badge]');
    var elBadgeValor = seccion.querySelector('[data-badge-valor]');
    var botonComprar = seccion.querySelector('[data-boton-comprar]');
    var botonTexto = seccion.querySelector('[data-boton-texto]');
    var imagenPrincipal = seccion.querySelector('[data-imagen-principal]');

    function formatearDinero(centimos) {
      var valor = (centimos / 100).toFixed(2).replace('.', ',');
      return valor + '€';
    }

    function opcionesSeleccionadas() {
      var valores = [];
      seccion.querySelectorAll('[data-opcion]').forEach(function (grupo) {
        var marcado = grupo.querySelector('[data-radio-opcion]:checked');
        valores.push(marcado ? marcado.value : null);
      });
      return valores;
    }

    function buscarVariante(valores) {
      return datosVariantes.find(function (v) {
        return valores.every(function (valor, i) {
          return v.options[i] === valor;
        });
      });
    }

    function actualizarVariante() {
      var valores = opcionesSeleccionadas();
      seccion.querySelectorAll('[data-opcion]').forEach(function (grupo, i) {
        var etiquetaValor = grupo.querySelector('[data-opcion-valor]');
        if (etiquetaValor && valores[i]) etiquetaValor.textContent = valores[i];
      });
      var variante = buscarVariante(valores);
      if (!variante) {
        if (botonComprar) {
          botonComprar.disabled = true;
          if (botonTexto) botonTexto.textContent = 'No disponible';
        }
        return;
      }
      if (inputVariante) inputVariante.value = variante.id;
      if (elPrecio) elPrecio.textContent = formatearDinero(variante.price);
      var hayOferta = variante.compare_at_price && variante.compare_at_price > variante.price;
      if (elPrecioAntiguo) {
        elPrecioAntiguo.style.display = hayOferta ? '' : 'none';
        if (hayOferta) elPrecioAntiguo.textContent = formatearDinero(variante.compare_at_price);
      }
      if (elAhorro) {
        elAhorro.style.display = hayOferta ? '' : 'none';
        if (hayOferta && elAhorroValor) elAhorroValor.textContent = formatearDinero(variante.compare_at_price - variante.price);
      }
      if (elBadge) {
        if (hayOferta) {
          elBadge.style.display = '';
          if (elBadgeValor) elBadgeValor.textContent = Math.round(((variante.compare_at_price - variante.price) / variante.compare_at_price) * 100);
        } else {
          elBadge.style.display = 'none';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        if (botonTexto) botonTexto.textContent = variante.available ? botonComprar.getAttribute('data-texto-disponible') || botonTexto.textContent : 'Agotado';
      }
      if (variante.featured_image && variante.featured_image.src && imagenPrincipal) {
        imagenPrincipal.src = variante.featured_image.src;
        imagenPrincipal.removeAttribute('srcset');
        if (imagenPrincipal.scrollIntoView && window.matchMedia('(min-width: 990px)').matches === false) {
          imagenPrincipal.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }

    if (botonComprar && botonTexto) {
      botonComprar.setAttribute('data-texto-disponible', botonTexto.textContent.trim());
    }

    seccion.querySelectorAll('[data-radio-opcion]').forEach(function (radio) {
      radio.addEventListener('change', actualizarVariante);
    });

    var inputCantidad = seccion.querySelector('[data-cantidad-input]');
    var btnMenos = seccion.querySelector('[data-cantidad-menos]');
    var btnMas = seccion.querySelector('[data-cantidad-mas]');
    if (btnMenos && inputCantidad) {
      btnMenos.addEventListener('click', function () {
        var actual = parseInt(inputCantidad.value, 10) || 1;
        if (actual > 1) inputCantidad.value = actual - 1;
      });
    }
    if (btnMas && inputCantidad) {
      btnMas.addEventListener('click', function () {
        var actual = parseInt(inputCantidad.value, 10) || 1;
        inputCantidad.value = actual + 1;
      });
    }

    seccion.querySelectorAll('[data-miniatura]').forEach(function (miniatura) {
      miniatura.addEventListener('click', function () {
        seccion.querySelectorAll('[data-miniatura]').forEach(function (m) {
          m.classList.remove('producto-mx-miniatura--activa');
        });
        miniatura.classList.add('producto-mx-miniatura--activa');
        if (imagenPrincipal) {
          imagenPrincipal.src = miniatura.getAttribute('data-url-grande');
          imagenPrincipal.removeAttribute('srcset');
        }
      });
    });

    seccion.querySelectorAll('[data-desplegable]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var desplegable = boton.closest('.producto-mx-desplegable');
        var abierto = desplegable.classList.toggle('producto-mx-abierto');
        boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  document.querySelectorAll('[data-producto-mx]').forEach(inicializarProducto);

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('[data-producto-mx]');
    if (seccion) inicializarProducto(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["RESENAS"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animarCifras(seccion) {
      var numeros = seccion.querySelectorAll('[data-numero]');
      if (numeros.length === 0) return;

      var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function formatear(valor, decimales, separador) {
        var fijo = valor.toFixed(decimales);
        var partes = fijo.split('.');
        if (separador === 'punto') {
          partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          return partes.length > 1 ? partes[0] + ',' + partes[1] : partes[0];
        } else if (separador === 'coma') {
          partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return partes.join('.');
        }
        return fijo.replace('.', ',');
      }

      function contar(el) {
        var destino = parseFloat(el.dataset.destino) || 0;
        var decimales = parseInt(el.dataset.decimales, 10) || 0;
        var separador = el.dataset.separador || 'ninguno';

        if (reducir) {
          el.textContent = formatear(destino, decimales, separador);
          return;
        }

        var duracion = 1400;
        var inicio = null;

        function paso(t) {
          if (inicio === null) inicio = t;
          var progreso = Math.min((t - inicio) / duracion, 1);
          var suavizado = 1 - Math.pow(1 - progreso, 3);
          el.textContent = formatear(destino * suavizado, decimales, separador);
          if (progreso < 1) {
            window.requestAnimationFrame(paso);
          } else {
            el.textContent = formatear(destino, decimales, separador);
          }
        }

        window.requestAnimationFrame(paso);
      }

      if ('IntersectionObserver' in window) {
        var observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              contar(entrada.target);
              observador.unobserve(entrada.target);
            }
          });
        }, { threshold: 0.4 });
        numeros.forEach(function (n) { observador.observe(n); });
      } else {
        numeros.forEach(contar);
      }
    }

    function iniciarMarquee(seccion) {
      var marquee = seccion.querySelector('.social-marquee');
      var track = seccion.querySelector('[data-track]');
      var grupo = seccion.querySelector('[data-grupo]');
      if (!marquee || !track || !grupo) return;

      var itemsBase = Array.prototype.slice.call(grupo.children);
      if (itemsBase.length === 0) return;

      var velocidad = parseFloat(seccion.dataset.velocidad) || 60;
      var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function construir() {
        track.classList.remove('social-track--animado');
        track.style.animationDuration = '';

        while (grupo.children.length > itemsBase.length) {
          grupo.removeChild(grupo.lastChild);
        }
        var clon = track.querySelector('[data-grupo-clon]');
        if (clon) track.removeChild(clon);

        var ancho = marquee.clientWidth;
        var guarda = 0;
        while (grupo.scrollWidth < ancho && guarda < 40) {
          itemsBase.forEach(function (item) { grupo.appendChild(item.cloneNode(true)); });
          guarda += 1;
        }

        if (reducir) return;

        var duplicado = grupo.cloneNode(true);
        duplicado.removeAttribute('data-grupo');
        duplicado.setAttribute('data-grupo-clon', 'true');
        duplicado.setAttribute('aria-hidden', 'true');
        track.appendChild(duplicado);

        var duracion = grupo.scrollWidth / velocidad;
        track.style.animationDuration = duracion.toFixed(2) + 's';
        track.classList.add('social-track--animado');
      }

      construir();

      var temporizador;
      window.addEventListener('resize', function () {
        window.clearTimeout(temporizador);
        temporizador = window.setTimeout(construir, 200);
      });
    }

    function iniciar(seccion) {
      if (seccion.dataset.socialListo === 'true') return;
      seccion.dataset.socialListo = 'true';
      animarCifras(seccion);
      iniciarMarquee(seccion);
    }

    function iniciarTodas() {
      document.querySelectorAll('[data-social]').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-social]');
      if (seccion) {
        seccion.dataset.socialListo = '';
        iniciar(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["REVIEW"] && !Shopify.designMode) return;
  try {
    
(function () {
  function inicializarResenas(seccion) {
    var pista = seccion.querySelector('[data-resenas-pista]');
    var btnAnterior = seccion.querySelector('[data-resenas-anterior]');
    var btnSiguiente = seccion.querySelector('[data-resenas-siguiente]');
    if (!pista || !btnAnterior || !btnSiguiente) return;

    function paso() {
      var tarjeta = pista.querySelector('[data-resena-tarjeta]');
      if (!tarjeta) return pista.clientWidth;
      var estilos = window.getComputedStyle(pista);
      var gap = parseInt(estilos.gap, 10) || 14;
      return tarjeta.getBoundingClientRect().width + gap;
    }

    function actualizarFlechas() {
      var maximo = pista.scrollWidth - pista.clientWidth - 2;
      btnAnterior.disabled = pista.scrollLeft <= 2;
      btnSiguiente.disabled = pista.scrollLeft >= maximo;
    }

    btnAnterior.addEventListener('click', function () {
      pista.scrollBy({ left: -paso(), behavior: 'smooth' });
    });

    btnSiguiente.addEventListener('click', function () {
      pista.scrollBy({ left: paso(), behavior: 'smooth' });
    });

    pista.addEventListener('scroll', actualizarFlechas, { passive: true });
    window.addEventListener('resize', actualizarFlechas);
    actualizarFlechas();
  }

  document.querySelectorAll('[data-carrusel-resenas]').forEach(inicializarResenas);

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('[data-carrusel-resenas]');
    if (seccion) inicializarResenas(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function inicializarPie(seccion) {
    seccion.querySelectorAll('[data-pie-acordeon]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 750px)').matches) return;
        var columna = boton.closest('.pie-mercuryal-columna');
        var abierta = columna.classList.toggle('pie-mercuryal-abierta');
        boton.setAttribute('aria-expanded', abierta ? 'true' : 'false');
      });
    });
  }

  document.querySelectorAll('[data-pie-mercuryal]').forEach(inicializarPie);

  document.addEventListener('shopify:section:load', function (evento) {
    var seccion = evento.target.querySelector('[data-pie-mercuryal]');
    if (seccion) inicializarPie(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    function crearEtiquetasMenu() {
      var cabecera = document.querySelector('[data-etiquetas-menu="true"]');
      if (!cabecera) return;

      var contenedores = document.querySelectorAll('.header__inline-menu, .menu-drawer');

      contenedores.forEach(function (contenedor) {
        if (contenedor.dataset.etiquetasProcesadas === 'true') return;
        contenedor.dataset.etiquetasProcesadas = 'true';

        var recorredor = document.createTreeWalker(contenedor, NodeFilter.SHOW_TEXT);
        var nodo;
        var nodosConEtiqueta = [];

        while ((nodo = recorredor.nextNode())) {
          if (/\[[^\]]+\]/.test(nodo.nodeValue)) {
            nodosConEtiqueta.push(nodo);
          }
        }

        nodosConEtiqueta.forEach(function (nodoTexto) {
          var partes = nodoTexto.nodeValue.match(/^([\s\S]*?)\[([^\]]+)\]([\s\S]*)$/);
          if (!partes) return;

          var fragmento = document.createDocumentFragment();
          var textoPrevio = partes[1].replace(/\s+$/, '');

          if (textoPrevio !== '') {
            fragmento.appendChild(document.createTextNode(textoPrevio));
          }

          var etiqueta = document.createElement('span');
          etiqueta.className = 'cabecera-velites__etiqueta';
          etiqueta.textContent = partes[2].trim();
          fragmento.appendChild(etiqueta);

          if (partes[3].trim() !== '') {
            fragmento.appendChild(document.createTextNode(partes[3]));
          }

          nodoTexto.parentNode.replaceChild(fragmento, nodoTexto);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', crearEtiquetasMenu);
    } else {
      crearEtiquetasMenu();
    }

    document.addEventListener('shopify:section:load', crearEtiquetasMenu);
  })();

  (function () {
    function hoverMenu() {
      var cabecera = document.querySelector('[data-menu-hover="true"]');
      if (!cabecera) return;

      var puntero = window.matchMedia('(hover: hover) and (pointer: fine)');
      var escritorio = window.matchMedia('(min-width: 990px)');

      function activo() {
        return puntero.matches && escritorio.matches;
      }

      var elementos = cabecera.querySelectorAll('.header__inline-menu > ul > li');

      elementos.forEach(function (li) {
        if (li.dataset.hoverListo === 'true') return;
        var detalle = li.querySelector('details');
        if (!detalle) return;
        li.dataset.hoverListo = 'true';

        var cerrar;

        function abrir() {
          if (!activo()) return;
          window.clearTimeout(cerrar);
          cabecera.querySelectorAll('.header__inline-menu > ul > li details[open]').forEach(function (d) {
            if (d !== detalle) d.removeAttribute('open');
          });
          detalle.setAttribute('open', '');
        }

        function programarCierre() {
          if (!activo()) return;
          cerrar = window.setTimeout(function () {
            detalle.removeAttribute('open');
          }, 120);
        }

        li.addEventListener('mouseenter', abrir);
        li.addEventListener('mouseleave', programarCierre);

        var resumen = detalle.querySelector('summary');
        if (resumen) {
          resumen.addEventListener('click', function (evento) {
            if (activo()) evento.preventDefault();
          });
        }
      });

      cabecera.addEventListener('mouseleave', function () {
        if (!activo()) return;
        cabecera.querySelectorAll('.header__inline-menu > ul > li details[open]').forEach(function (d) {
          d.removeAttribute('open');
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hoverMenu);
    } else {
      hoverMenu();
    }

    document.addEventListener('shopify:section:load', hoverMenu);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(seccion) {
      if (seccion.dataset.instaListo === 'true') return;

      var marquee = seccion.querySelector('.insta-marquee');
      var track = seccion.querySelector('[data-track]');
      var grupo = seccion.querySelector('[data-grupo]');
      if (!marquee || !track || !grupo) return;

      var itemsBase = Array.prototype.slice.call(grupo.children);
      if (itemsBase.length === 0) return;

      seccion.dataset.instaListo = 'true';

      var velocidad = parseFloat(seccion.dataset.velocidad) || 40;
      var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function construir() {
        track.classList.remove('insta-track--animado');
        track.style.animationDuration = '';

        while (grupo.children.length > itemsBase.length) {
          grupo.removeChild(grupo.lastChild);
        }
        var clon = track.querySelector('[data-grupo-clon]');
        if (clon) track.removeChild(clon);

        var ancho = marquee.clientWidth;
        var guarda = 0;
        while (grupo.scrollWidth < ancho && guarda < 40) {
          itemsBase.forEach(function (item) { grupo.appendChild(item.cloneNode(true)); });
          guarda += 1;
        }

        if (reducir) return;

        var duplicado = grupo.cloneNode(true);
        duplicado.removeAttribute('data-grupo');
        duplicado.setAttribute('data-grupo-clon', 'true');
        duplicado.setAttribute('aria-hidden', 'true');
        track.appendChild(duplicado);

        var duracion = grupo.scrollWidth / velocidad;
        track.style.animationDuration = duracion.toFixed(2) + 's';
        track.classList.add('insta-track--animado');
      }

      construir();

      var temporizador;
      window.addEventListener('resize', function () {
        window.clearTimeout(temporizador);
        temporizador = window.setTimeout(construir, 200);
      });
    }

    function iniciarTodas() {
      document.querySelectorAll('[data-insta]').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-insta]');
      if (seccion) {
        seccion.dataset.instaListo = '';
        iniciar(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preguntas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animarCifras(seccion) {
      var numeros = seccion.querySelectorAll('[data-numero]');
      if (numeros.length === 0) return;
      var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function formatear(valor, decimales, separador) {
        var fijo = valor.toFixed(decimales);
        var partes = fijo.split('.');
        if (separador === 'punto') {
          partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          return partes.length > 1 ? partes[0] + ',' + partes[1] : partes[0];
        } else if (separador === 'coma') {
          partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return partes.join('.');
        }
        return fijo.replace('.', ',');
      }

      function contar(el) {
        var destino = parseFloat(el.dataset.destino) || 0;
        var decimales = parseInt(el.dataset.decimales, 10) || 0;
        var separador = el.dataset.separador || 'ninguno';
        if (reducir) { el.textContent = formatear(destino, decimales, separador); return; }
        var duracion = 1400;
        var inicio = null;
        function paso(t) {
          if (inicio === null) inicio = t;
          var progreso = Math.min((t - inicio) / duracion, 1);
          var suavizado = 1 - Math.pow(1 - progreso, 3);
          el.textContent = formatear(destino * suavizado, decimales, separador);
          if (progreso < 1) { window.requestAnimationFrame(paso); }
          else { el.textContent = formatear(destino, decimales, separador); }
        }
        window.requestAnimationFrame(paso);
      }

      if ('IntersectionObserver' in window) {
        var observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) { contar(entrada.target); observador.unobserve(entrada.target); }
          });
        }, { threshold: 0.4 });
        numeros.forEach(function (n) { observador.observe(n); });
      } else { numeros.forEach(contar); }
    }

    function iniciarMarquee(seccion) {
      var marquee = seccion.querySelector('.social-marquee');
      var track = seccion.querySelector('[data-track]');
      var grupo = seccion.querySelector('[data-grupo]');
      if (!marquee || !track || !grupo) return;
      var itemsBase = Array.prototype.slice.call(grupo.children);
      if (itemsBase.length === 0) return;
      var velocidad = parseFloat(seccion.dataset.velocidad) || 60;
      var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function construir() {
        track.classList.remove('social-track--animado');
        track.style.animationDuration = '';
        while (grupo.children.length > itemsBase.length) { grupo.removeChild(grupo.lastChild); }
        var clon = track.querySelector('[data-grupo-clon]');
        if (clon) track.removeChild(clon);
        var ancho = marquee.clientWidth;
        var guarda = 0;
        while (grupo.scrollWidth < ancho && guarda < 40) {
          itemsBase.forEach(function (item) { grupo.appendChild(item.cloneNode(true)); });
          guarda += 1;
        }
        if (reducir) return;
        var duplicado = grupo.cloneNode(true);
        duplicado.removeAttribute('data-grupo');
        duplicado.setAttribute('data-grupo-clon', 'true');
        duplicado.setAttribute('aria-hidden', 'true');
        track.appendChild(duplicado);
        var duracion = grupo.scrollWidth / velocidad;
        track.style.animationDuration = duracion.toFixed(2) + 's';
        track.classList.add('social-track--animado');
      }

      construir();
      var temporizador;
      window.addEventListener('resize', function () {
        window.clearTimeout(temporizador);
        temporizador = window.setTimeout(construir, 200);
      });
    }

    function iniciar(seccion) {
      if (seccion.dataset.socialListo === 'true') return;
      seccion.dataset.socialListo = 'true';
      animarCifras(seccion);
      iniciarMarquee(seccion);
    }

    function iniciarTodas() { document.querySelectorAll('[data-social]').forEach(iniciar); }

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', iniciarTodas); }
    else { iniciarTodas(); }

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-social]');
      if (seccion) { seccion.dataset.socialListo = ''; iniciar(seccion); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarPortada(seccion) {
      if (seccion.dataset.portadaLista === 'true') return;

      var track = seccion.querySelector('[data-track]');
      var slides = seccion.querySelectorAll('[data-slide]');
      if (!track || slides.length <= 1) {
        seccion.dataset.portadaLista = 'true';
        return;
      }

      seccion.dataset.portadaLista = 'true';

      var puntos = seccion.querySelectorAll('[data-ir]');
      var botonReproducir = seccion.querySelector('[data-reproducir]');
      var total = slides.length;
      var indice = 0;
      var intervalo = null;

      var autoplay = seccion.dataset.autoplay === 'true';
      var tiempo = parseInt(seccion.dataset.intervalo, 10) || 5000;
      var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function mostrar(i) {
        indice = (i + total) % total;
        track.style.transform = 'translateX(-' + indice * 100 + '%)';
        puntos.forEach(function (punto, p) {
          punto.classList.toggle('portada-punto--activo', p === indice);
        });
      }

      function siguiente() {
        mostrar(indice + 1);
      }

      function arrancar() {
        if (!autoplay || reducirMovimiento) return;
        detener();
        intervalo = window.setInterval(siguiente, tiempo);
        seccion.classList.remove('seccion-portada--pausada');
      }

      function detener() {
        if (intervalo) {
          window.clearInterval(intervalo);
          intervalo = null;
        }
      }

      puntos.forEach(function (punto) {
        punto.addEventListener('click', function () {
          mostrar(parseInt(punto.dataset.ir, 10));
          if (autoplay && intervalo) {
            arrancar();
          }
        });
      });

      if (botonReproducir) {
        botonReproducir.addEventListener('click', function () {
          if (intervalo) {
            detener();
            seccion.classList.add('seccion-portada--pausada');
            botonReproducir.setAttribute('aria-label', 'Reproducir');
          } else {
            arrancar();
            botonReproducir.setAttribute('aria-label', 'Pausar');
          }
        });
      }

      mostrar(0);
      arrancar();
    }

    function iniciarTodas() {
      document.querySelectorAll('[data-portada]').forEach(iniciarPortada);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-portada]');
      if (seccion) {
        seccion.dataset.portadaLista = '';
        iniciarPortada(seccion);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
